import { Box, Skeleton, Stack } from "@mui/material";

export default function InspectorInspectionSkeleton() {
  return (
    <Box className="h-100" sx={{ display: "flex", flexDirection: "column" }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1.5, px: 0.5 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={220} height={28} />
        </Stack>
        <Skeleton variant="rounded" width={80} height={32} />
      </Stack>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          minHeight: 0,
          border: "1px solid #E5E7EB",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* Left tree skeleton */}
        <Box
          sx={{
            width: 360,
            borderRight: "1px solid #E5E7EB",
            p: 1.5,
            display: { xs: "none", md: "block" },
            bgcolor: "#FAFBFC",
          }}
        >
          {Array.from({ length: 2 }).map((_, floorIdx) => (
            <Box key={floorIdx} sx={{ mb: 2 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Skeleton variant="text" width={100} height={22} />
                <Skeleton variant="text" width={40} height={18} />
              </Stack>
              <Box sx={{ border: "1px solid #E5E7EB", borderRadius: 2, p: 1, mb: 1 }}>
                <Skeleton variant="text" width="60%" height={18} sx={{ mb: 1 }} />
                {Array.from({ length: 3 }).map((_, i) => (
                  <Stack key={i} direction="row" spacing={1} alignItems="center" sx={{ py: 0.75 }}>
                    <Skeleton variant="circular" width={8} height={8} />
                    <Box sx={{ flex: 1 }}>
                      <Skeleton variant="text" width="80%" height={16} />
                      <Skeleton variant="text" width="40%" height={12} />
                    </Box>
                  </Stack>
                ))}
              </Box>
            </Box>
          ))}
        </Box>

        {/* Right detail skeleton */}
        <Box sx={{ flex: 1, p: 2 }}>
          <Skeleton variant="rounded" height={56} sx={{ mb: 2, borderRadius: 1 }} />
          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="40%" height={22} />
              <Skeleton variant="text" width="100%" height={16} />
              <Skeleton variant="text" width="95%" height={16} />
              <Skeleton variant="text" width="80%" height={16} />
              <Skeleton variant="rounded" height={120} sx={{ mt: 2, borderRadius: 1 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="35%" height={22} />
              <Skeleton variant="rounded" height={100} sx={{ mt: 1, mb: 2, borderRadius: 1 }} />
              <Stack direction="row" spacing={1}>
                <Skeleton variant="rounded" width={90} height={36} />
                <Skeleton variant="rounded" width={90} height={36} />
                <Skeleton variant="rounded" width={90} height={36} />
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
